var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// URLS
var API_BASE_URL = 'https://api.poap.xyz';
var APP_BASE_URL = 'https://app.poap.xyz';
var Plugin = /** @class */ (function () {
    function Plugin() {
        this.author = 'Poap-xyz';
        this.version = '1.0.0';
        this.name = 'Poap Module';
    }
    Plugin.prototype.openScanPage = function (address) {
        window.open(APP_BASE_URL + "/scan/" + address, '_blank');
    };
    Plugin.prototype.getCurrentState = function (snapshot, address) {
        return __awaiter(this, void 0, void 0, function () {
            var eventResponse, image_url, addressResponse, _a, claimed, status, voted;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetch(API_BASE_URL + "/snapshot/proposal/" + snapshot)];
                    case 1:
                        eventResponse = _b.sent();
                        // If the fetch fails: the event doesn't exists for this poap yet
                        if (!eventResponse.ok) {
                            return [2 /*return*/, { image_url: '', currentState: 'NO_POAP' }];
                        }
                        return [4 /*yield*/, eventResponse.json()];
                    case 2:
                        image_url = (_b.sent()).image_url;
                        // Check that the address is not empty
                        if (!address) {
                            return [2 /*return*/, { image_url: image_url, currentState: 'NOT_VOTED' }];
                        }
                        return [4 /*yield*/, fetch(API_BASE_URL + "/snapshot/proposal/" + snapshot + "/" + address)];
                    case 3:
                        addressResponse = _b.sent();
                        // If the fetch failed return the NOT_VOTED state
                        if (!addressResponse.ok) {
                            return [2 /*return*/, { image_url: image_url, currentState: 'NOT_VOTED' }];
                        }
                        return [4 /*yield*/, addressResponse.json()];
                    case 4:
                        _a = _b.sent(), claimed = _a.claimed, status = _a.status, voted = _a.voted;
                        if (claimed) {
                            // If the address claim the token but the status is not passed
                            // it means that the token is being minted
                            if (claimed && status !== 'passed') {
                                return [2 /*return*/, { image_url: image_url, currentState: 'LOADING' }];
                            }
                            // If the status is passed: the token was claimed
                            return [2 /*return*/, { image_url: image_url, currentState: 'CLAIMED' }];
                        }
                        else if (voted) {
                            // The token is not claimed but the address voted
                            return [2 /*return*/, { image_url: image_url, currentState: 'UNCLAIMED' }];
                        }
                        return [2 /*return*/, { image_url: image_url, currentState: 'NOT_VOTED' }];
                }
            });
        });
    };
    Plugin.prototype.claim = function (snapshot, address) {
        return __awaiter(this, void 0, void 0, function () {
            var body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = {
                            snapshotProposalHash: snapshot,
                            address: address
                        };
                        return [4 /*yield*/, fetch(API_BASE_URL + "/claim/snapshot-proposal", {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(body)
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            // If the response is not ok: return the UNCLAIMED state
                            console.log(response.json());
                            return [2 /*return*/, 'UNCLAIMED'];
                        }
                        return [2 /*return*/, 'LOADING'];
                }
            });
        });
    };
    return Plugin;
}());
export default Plugin;
